import { render, staticRenderFns } from "./dlg_hospitalization_edit_dx.vue?vue&type=template&id=a8edf812"
import script from "./dlg_hospitalization_edit_dx.vue?vue&type=script&lang=js"
export * from "./dlg_hospitalization_edit_dx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports